var map = {
	"./BEETBOOT WINE.jpg": 4042,
	"./BLACK GRAPES WINE.jpg": 5151,
	"./CHIKKU WINE.jpg": 6845,
	"./DRAGON FRUIT WINE.jpeg": 7992,
	"./GINGER WINE.jpg": 8466,
	"./GREEN GRAPES WINE.jpg": 95,
	"./JAMUN WINE.jpg": 13,
	"./KISHMISH WINE.jpg": 2676,
	"./MANGO WINE.jpg": 16,
	"./MOHUA WINE.jpeg": 3305,
	"./PINEAPPLE WINE.jpg": 1504,
	"./POMEGRANATE WINE.jpeg": 9858,
	"./ROSE WINE.jpg": 4337,
	"./WATERL MELOM WINE.jpg": 2653,
	"./WHITE JAMUN WINE 1.jpg": 813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7022;